<template>
  <el-card class="card-box">
    <div class="h-search">
      <div ref="search" class="h-search-box">
        <div
          v-for="(i, index) in list"
          v-show="index < showNum || more || showNum === 0"
          :key="i.slotName"
          class="h-search-item"
          :style="{ width: i.width + 'px' }"
        >
          <div class="h-search-item__label" :style="{ width: labelWidth + 'px' }">
            <span>{{ i.label }}</span>
          </div>
          <div class="h-search-item__right">
            <slot :name="i.slotName" :row="i.item">
              <component
                :is="i.componentType"
                v-if="i.componentType"
                v-model="form[i.bindName]"
                v-bind="i.$attrs"
                v-on="i.$listeners"
              />
            </slot>
          </div>
        </div>
        <div class="h-search-item" :style="handleStyle">
          <div class="h-search-item__label" :style="{ width: labelWidth + 'px' }"></div>
          <div class="h-search__handle">
            <el-button type="primary" icon="el-icon-search" :loading="loading" @click="query">
              搜索
            </el-button>
            <el-button v-if="showReset" icon="el-icon-remove" @click="clearAll">
              重置
            </el-button>
            <el-button
              v-if="list.length > showNum && showNum !== 0"
              type="text"
              :class="!more ? 'fc-normal' : ''"
              @click="showMore"
            >
              {{ more ? '收起' : '展开' }}
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
import {
  // debounce,
  pick
} from '@/utils'

const componentMap = {
  input: 'el-input',
  select: 'z-select',
  datePicker: 'el-date-picker',
  dict: 'dict-select'
}
export default {
  name: 'SearchArea',
  props: {
    options: {
      type: Array,
      required: true
    },
    value: {},
    foldSearch: {
      type: Boolean,
      default: true
    },
    excludeValue: {
      type: Array,
      default() {
        return ['', null, undefined]
      }
    },
    showNum: {
      type: Number,
      default: 0
    },
    itemWidth: {
      type: Number,
      default: 340
    },
    labelWidth: {
      type: Number,
      default: 80
    },
    loading: {
      type: Boolean,
      default: false
    },
    showReset: {
      type: Boolean,
      default: true
    },
    init: {
      type: Function
    },
    handleOneLine: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      form: this.value || {},
      more: !this.foldSearch,
      ready: true,
      list: [],
      fnArrays: [],
      minHeight: 42
    }
  },
  computed: {
    handleStyle() {
      const tmp = { marginBottom: 0 }
      if (this.handleOneLine) {
        tmp.flexBasis = '100%'
      }
      return tmp
    }
  },
  watch: {
    options: {
      handler(values) {
        this.fnArrays = []
        var vm = this
        this.list = this.options.map((item, index) => {
          const c = {}
          const {
            label,
            searchType,
            selectOptions,
            focus,
            change,
            blur,
            style,
            span,
            slotName,
            component,
            ...other
          } = item
          c.slotName = slotName || item.name
          c.bindName = item.name
          if (Array.isArray(item.name) && !slotName) {
            c.slotName = item.name.join('_')
            c.bindName = item.name.join('_')
          }
          c.$listeners = {}
          c.label = label
          c.name = item.name
          c.value = this.form[item.name]
          ;['change', 'blur', 'focus'].forEach(method => {
            if (item[method]) {
              c.$listeners[method] = item[method]
            }
          })
          c.componentType = component || componentMap[searchType]
          let attrsTmp = {}
          if (item.searchType === 'input') {
            other.placeholder = other.placeholder || `请输入${item.label}`
          }
          if (item.searchType === 'dict') {
            other.placeholder = other.placeholder || '全部'
          }
          if (['datetimerange', 'daterange'].includes(item.type)) {
            c.span = c.span || 2
            const m = `yyyy-MM-dd${item.type === 'datetimerange' ? ' HH:mm:ss' : ''}`
            const d = item.type === 'datetimerange' ? '时间' : '日期'
            attrsTmp = {
              defaultTime: ['00:00:00', '23:59:59'],
              format: m,
              valueFormat: m,
              startPlaceholder: '开始' + d,
              endPlaceholder: '结束' + d
            }
          }
          c.span = item.span || 1
          if (Array.isArray(item.name)) {
            c.$listeners.change = function(val) {
              change && change(val)
              const value = val || []
              item.name.forEach((k, index) => {
                vm.form[k] = value[index]
              })
            }
          }
          c.width = this.calcItemWidth(c.span)
          c.$attrs = Object.assign({}, attrsTmp, other)
          if (!('clearable' in item)) {
            c.$attrs.clearable = true
          }
          if (item.selectOptions) {
            c.$attrs.options = item.selectOptions
          } else if (item.optionfn) {
            this.fnArrays.push({ target: item, index, fn: resolve => item.optionfn(resolve) })
          }
          c.item = {
            ...item
          }
          return c
        })
        if (this.fnArrays.length) {
          this.fnArrays.forEach(item => {
            new Promise((resolve, reject) => {
              this.list[item.index].$attrs['no-data-text'] = '加载中'
              const obj = this.list[item.index]
              this.list.splice(item.index, 1, obj)
              item.fn(resolve)
            }).then(datas => {
              this.list[item.index].$attrs.options = datas
              this.list[item.index].$attrs['no-data-text'] = null
              const obj = this.list[item.index]
              this.list.splice(item.index, 1, obj)
            })
          })
        }
      },
      immediate: true
    },
    value(val) {
      this.form = this.value
    },
    form: {
      handler(val) {
        this.$emit('input', val)
      },
      deep: true
    }
  },
  mounted() {
    if (this.init) {
      const data = this.getSearchParams()
      this.init(data)
    }
  },
  destroyed() {},
  methods: {
    calcItemWidth(span) {
      return span * this.itemWidth + (span - 1) * 16
    },
    showMore() {
      this.more = !this.more
      this.$emit('click-more', this.more)
    },
    query() {
      const data = this.getSearchParams()
      this.$emit('do-search', data)
    },
    clearAll() {
      this.form = {}
      this.$emit('do-reset', this.form)
    },
    getSearchParams(params) {
      params = params || this.form
      const keys = this.options.reduce(
        (arr, item) => [...arr, ...(Array.isArray(item.name) ? item.name : [item.name])],
        []
      )
      const data = pick(params, keys, item => !this.excludeValue.includes(params[item]))
      return data
    }
  }
}
</script>

<style lang="scss">
$--srach-item-label-width: 110px;
$--srach-item-input-width: 170px;
$--search-margin: $--base-margin;

.h-search {
  // background-color: #fff;
  // margin-bottom: 10px;
  // box-shadow: 0 0 2px #CBCCD2;
  // padding: $--base-padding;
  // box-sizing: border-box;
  padding-right: 0;
  padding-bottom: 0;
  overflow: hidden;
  &-box {
    display: flex;
    flex-flow: row wrap;
    margin-right: -10px;
    overflow: hidden;
  }
  &-item {
    display: flex;
    margin-bottom: $--search-margin;
    margin-right: $--search-margin;
    &__label {
      display: inline-flex;
      justify-content: flex-end;
      align-items: center;
      margin-right: 10px;
      flex-shrink: 0;
    }
    &__right {
      flex: 1;
    }
  }

  .el-date-editor--datetimerange,
  .el-date-editor--daterange {
    &.el-input__inner {
      width: 100%;
    }
  }
  .el-select {
    display: block;
  }
}
</style>
